export const enum ClosureActionTypes {
  FETCH_REQUEST = '[closure]FETCH_REQUEST',
  FETCH_SUCCESS = '[closure]FETCH_SUCCESS',
  FETCH_ERROR = '[closure]FETCH_ERROR'
}

export interface ClosureState {
  readonly loading: boolean;
  readonly updated: boolean;
  readonly data?: File;
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/closure/types.ts